import React, { Component } from 'react'
import { connect } from 'react-redux';

import { customSecondsElapsedForMomentaryObservation } from '../actions/BehaviourDataActions'

class TimerForMomentaryObservation extends Component {

    componentDidMount = () => {
        this.props.observationIncrementerTwo.map((obj, index) => {
            return clearInterval(this.props.observationIncrementerTwo[0]);
        })
        if (this.props.isStart) {
            this.props.customSecondsElapsedForMomentaryObservation("mount")
        }
    } 

    componentWillUnmount = () => {
        this.props.observationIncrementerOne.map((obj, index) => {
            return clearInterval(this.props.observationIncrementerOne[0]);
        })
        if(!this.props.isSave){
            this.props.customSecondsElapsedForMomentaryObservation("unmount")
        }
    }

    getSeconds = () => {
        return ('0' + this.props.observationSecondsElapsed % 60).slice(-2)
    }

    getMinutes = () => {
        return Math.floor(this.props.observationSecondsElapsed / 60)
    }

    render() {
        return (
            <div>
                {this.getMinutes()}:{this.getSeconds()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isStart: state.patientRecordMomentaryCustomReducer.isStart,
        observationSecondsElapsed: state.patientRecordMomentaryCustomReducer.observationSecondsElapsed,
        observationIncrementerOne: state.patientRecordMomentaryCustomReducer.observationIncrementerOne,
        observationIncrementerTwo: state.patientRecordMomentaryCustomReducer.observationIncrementerTwo
    }
}

export default connect(mapStateToProps, {customSecondsElapsedForMomentaryObservation})(TimerForMomentaryObservation);




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/TimerForMomentaryObservation.js